import { colors } from "../../Styles";

export function BluePrint({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} version="1.1" viewBox="0 0 218 218" >
 <g transform="matrix(1,0,0,0.75,0,0)">
        <path d="M212,8C206.116,0.154 200,0 200,0L18,0C18,0 11.884,0.154 6,8C0,16 0,24 0,24L0,266.667C0,266.667 -0,274.667 6,282.667C12,290.667 18,290.667 18,290.667L200,290.667C200,290.667 206.116,290.513 212,282.667C217.884,274.821 218,266.667 218,266.667L218,48L200,48L200,242.667C200,242.667 201,260 198,264C195,268 182,266.667 182,266.667L36,266.667C36,266.667 23,268 20,264C17,260 18,242.667 18,242.667L18,48C18,48 17,30.667 20,26.667C23,22.667 36,24 36,24L182,24C182,24 195,22.667 198,26.667C201,30.667 200,48 200,48L218,48L218,24C218,24 218,16 212,8Z"/>
    </g>
    <g transform="matrix(1.82573e-17,-0.298165,2.79167,1.7094e-16,34.5,99.5)">
        <rect x="0" y="0" width="218" height="24"/>
    </g>
    <g transform="matrix(4.18515e-17,-0.683486,2.58333,1.58184e-16,121.5,183.5)">
        <rect x="0" y="0" width="218" height="24"/>
    </g>
    <g transform="matrix(1.82573e-17,-0.298165,2.79167,1.7094e-16,34.5,183.5)">
        <rect x="0" y="0" width="218" height="24"/>
    </g>
    </svg>
  );
}